import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook } from 'lucide-react';
import { businessInfo } from '../mock';

const Footer = () => {
  return (
    <footer style={{background: 'var(--bg-page)', borderTop: '1px solid var(--border-medium)'}}>
      <div className="container" style={{padding: '80px 40px 40px'}}>
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '48px', marginBottom: '60px'}}>
          {/* Company Info */}
          <div>
            <h3 className="heading-5" style={{color: 'var(--brand-primary)', marginBottom: '16px'}}>SBF HOME IMPROVEMENTS LLC</h3>
            <p className="body-small" style={{color: 'var(--text-secondary)', lineHeight: '1.6', marginBottom: '16px'}}>
              Professional home improvement services in Pennsylvania. Licensed, insured, and committed to quality craftsmanship.
            </p>
            <p className="caption" style={{color: 'var(--text-primary)', marginTop: '12px'}}>PA LICENSE #{businessInfo.license}</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-6" style={{color: 'var(--text-primary)', marginBottom: '16px'}}>Quick Links</h4>
            <nav style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
              <Link to="/" className="body-small" style={{color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.3s ease'}}>Home</Link>
              <Link to="/about" className="body-small" style={{color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.3s ease'}}>About Us</Link>
              <Link to="/services" className="body-small" style={{color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.3s ease'}}>Services</Link>
              <Link to="/gallery" className="body-small" style={{color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.3s ease'}}>Gallery</Link>
              <Link to="/testimonials" className="body-small" style={{color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.3s ease'}}>Testimonials</Link>
              <Link to="/contact" className="body-small" style={{color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.3s ease'}}>Contact</Link>
            </nav>
          </div>

          {/* Services */}
          <div>
            <h4 className="heading-6" style={{color: 'var(--text-primary)', marginBottom: '16px'}}>Our Services</h4>
            <nav style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
              <span className="body-small" style={{color: 'var(--text-secondary)'}}>Roof Replacements</span>
              <span className="body-small" style={{color: 'var(--text-secondary)'}}>Siding Installation</span>
              <span className="body-small" style={{color: 'var(--text-secondary)'}}>Flooring Installation</span>
              <span className="body-small" style={{color: 'var(--text-secondary)'}}>General Repairs</span>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="heading-6" style={{color: 'var(--text-primary)', marginBottom: '16px'}}>Contact Us</h4>
            <div style={{display: 'flex', flexDirection: 'column', gap: '16px'}}>
              <a href={`tel:${businessInfo.phone}`} style={{display: 'flex', alignItems: 'center', gap: '12px', textDecoration: 'none', color: 'var(--text-secondary)', transition: 'color 0.3s ease'}}>
                <Phone size={16} color="var(--brand-primary)" />
                <span className="body-small">{businessInfo.phone}</span>
              </a>
              <a href={`mailto:${businessInfo.email}`} style={{display: 'flex', alignItems: 'center', gap: '12px', textDecoration: 'none', color: 'var(--text-secondary)', transition: 'color 0.3s ease'}}>
                <Mail size={16} color="var(--brand-primary)" />
                <span className="body-small">{businessInfo.email}</span>
              </a>
              <div style={{display: 'flex', alignItems: 'flex-start', gap: '12px'}}>
                <MapPin size={16} color="var(--brand-primary)" style={{marginTop: '2px', flexShrink: 0}} />
                <span className="body-small" style={{color: 'var(--text-secondary)'}}>{businessInfo.address}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{borderTop: '1px solid var(--border-medium)', paddingTop: '32px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px'}}>
          <p className="body-small" style={{color: 'var(--text-secondary)'}}>
            © {new Date().getFullYear()} SBF Home Improvements LLC. All rights reserved.
          </p>
          <div style={{display: 'flex', alignItems: 'center', gap: '24px'}}>
            <a 
              href="https://www.facebook.com/sbfhomeimprovements" 
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                background: 'var(--brand-primary)',
                transition: 'all 0.3s ease',
                textDecoration: 'none'
              }}
              className="facebook-icon-link"
            >
              <Facebook size={20} color="white" />
            </a>
            <Link to="/" className="body-small" style={{color: 'var(--text-secondary)', textDecoration: 'none'}}>Privacy Policy</Link>
            <Link to="/" className="body-small" style={{color: 'var(--text-secondary)', textDecoration: 'none'}}>Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;